import { Component, Vue } from 'vue-property-decorator';
import { SelectOption } from '@/types/types';

// gql
import fetchCountriesQuery from '@/graphql/queries/FetchCountries.gql';

import i18n from '@/plugins/i18n';

@Component({
  apollo: {
    countryOptions: {
      query: fetchCountriesQuery,
      debounce: 300,
      prefetch: true,
      variables() {
        return { countryArgs: { search: this.searchCountry } };
      },
      update(data): SelectOption<string>[] {
        if (data.countries) {
          return data.countries.map((country: any) => {
            return {
              label: `${country.unLocode} - ${country.nameTranslations[this.lang || 'ja']}`,
              value: country
            };
          });
        }
        return [];
      }
    }
  }
})

export default class CountryOptionsMixin extends Vue {
  public countryOptions: SelectOption<string>[] = [];
  public searchCountry = '';
  // to manually set language
  public lang = i18n.locale || 'ja';
}
